import React, { useEffect, useState } from 'react';

import useStyles from './styles';

interface Props {
    cveId: string;
    references: string[];
}

const RelatedBox: React.FC<Props> = ({ references, cveId }) => {
    const { classes } = useStyles();
    const [tags, setTags] = useState({});

    useEffect(() => {
        setTags(
            Object.keys(references).reduce((acc, value) => {
                const tag = references[value][0].bulletinFamily;
                acc[tag] = (acc[tag] || 0) + references[value].length;
                return acc;
            }, {})
        );
    }, [references]);

    return (
        <div className={classes.root}>
            <div className={classes.title}>Related for {cveId}</div>
            <div className={classes.tags}>
                {Object.keys(tags).map((tag, index) => (
                    <a key={'related-box-' + index} className={classes.tag} href={'#related'}>
                        <span>{tag}</span>
                        <span className={classes.tagValue}>{tags[tag]}</span>
                    </a>
                ))}
            </div>
        </div>
    );
};
export default RelatedBox;
